<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pricing.country.deletePrice.title' | translate: { bundle: row()?.name } }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-md-6">
        <label class="label mb-1">
          {{ 'pricing.country.deletePrice.type' | translate }}
        </label>
        <app-select
          class="d-block"
          data-cy="country-delete-type-select"
          [selected]="selectedType()"
          (changed)="selectedType.set($event)"
        >
          @for (type of deletableTypes(); track type) {
            <app-select-option
              [label]="'pricing.country.priceTypes.' + type | translate"
              [value]="type"
            />
          }
        </app-select>
      </div>
    </div>
    @if (selectedPrice(); as price) {
      <p class="mt-3 mb-0">
        {{
          'pricing.country.deletePrice.message'
            | translate
              : {
                  type: selectedType(),
                  price: price.pivot.price | number: '1.2-2',
                  currency: currency() ?? '',
                  validFrom: price.pivot.validFrom | date: 'dd.MM.yyyy'
                }
        }}
      </p>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutofocus
      type="button"
      class="btn btn-clear"
      data-cy="close-btn"
      (click)="modalRef.close()"
    >
      {{ 'common.buttons.btnCancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-cy="delete-country-price-btn"
      [disabled]="!selectedPrice()"
      (click)="delete()"
    >
      {{ 'common.buttons.btnRemove' | translate }}
    </button>
  </div>
</div>
